// Client-side file logger for debugging
class FileLogger {
  constructor(filename = 'client-debug.log') {
    this.filename = filename;
    this.logs = [];
    this.maxLogs = 1000; // Keep last 1000 log entries in memory
  }

  log(level, category, message, data = null) {
    const timestamp = new Date().toISOString();
    const logEntry = {
      timestamp,
      level,
      category,
      message,
      data: data ? JSON.stringify(data, null, 2) : null
    };
    
    this.logs.push(logEntry);
    
    // Keep only the most recent logs
    if (this.logs.length > this.maxLogs) {
      this.logs = this.logs.slice(-this.maxLogs);
    }
    
    // Send to server to write to file
    this.sendToServer(logEntry);
  }

  async sendToServer(logEntry) {
    try {
      const isProduction = import.meta.env.MODE === 'production';
      const baseUrl = isProduction ? 'https://grotto.fm' : 'http://localhost:4000';
      
      await fetch(`${baseUrl}/api/debug-log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(logEntry)
      });
    } catch (error) {
      // Fallback to console if server logging fails
      console.error('Failed to send log to server:', error);
    }
  }

  // Convenience methods
  debug(category, message, data) {
    this.log('DEBUG', category, message, data);
  }

  info(category, message, data) {
    this.log('INFO', category, message, data);
  }

  warn(category, message, data) {
    this.log('WARN', category, message, data);
  }

  error(category, message, data) {
    this.log('ERROR', category, message, data);
  }

  // Get logs for analysis
  getLogs(category = null) {
    if (category) {
      return this.logs.filter(log => log.category === category);
    }
    return this.logs;
  }
}

// Create singleton instance
const logger = new FileLogger('ws-debug.log');

export default logger;